import {NewMarkdownViewer} from '@github-ui/markdown-viewer/NewMarkdownViewer'
import type {SafeHTMLString} from '@github-ui/safe-html'
import {GitHubAvatar} from '@github-ui/github-avatar'
import {ExpandableContent} from './ExpandableContent'
import styles from './Description.module.css'

type OverviewDescriptionProps = {
  descriptionHtml: SafeHTMLString | null
  author: {
    login: string
    avatarUrl?: string | null
  }
}

/** PR description section on the Overview tab with expandable overflow */
export function Description({descriptionHtml, author}: OverviewDescriptionProps) {
  const isEmptyDescription = !descriptionHtml || descriptionHtml === ''
  // eslint-disable-next-line @github-ui/github-monorepo/no-cast-as-safe-html-string -- static string literal is safe
  const placeholderText = 'No description provided.' as SafeHTMLString

  return (
    <section className={styles.container} aria-label="Description">
      <div className={styles.header}>
        {author.avatarUrl ? <GitHubAvatar src={author.avatarUrl} /> : null}
        <span>
          <strong>{author.login}</strong> <span className="fgColor-muted">wrote</span>
        </span>
      </div>
      <ExpandableContent sectionLabel="Description" storageKey="overview-description-expanded" defaultExpanded>
        <NewMarkdownViewer
          verifiedHTML={isEmptyDescription ? placeholderText : descriptionHtml}
          className={isEmptyDescription ? 'fgColor-muted text-italic' : undefined}
        />
      </ExpandableContent>
    </section>
  )
}
